import { render, staticRenderFns } from "./qr_call.vue?vue&type=template&id=2ed1f653&scoped=true"
import script from "./qr_call.vue?vue&type=script&lang=js"
export * from "./qr_call.vue?vue&type=script&lang=js"
import style0 from "./qr_call.vue?vue&type=style&index=0&id=2ed1f653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1f653",
  null
  
)

export default component.exports